var JsonEditorServerService = function (jsonrpc) {
    var service = jsonrpc.newService('json_editor');
    this.get = service.createMethod('get');
    this.get_schema = service.createMethod('get_schema');
    this.get_model = service.createMethod('get_model');
    this.update_model = service.createMethod('update_model');
};
JsonEditorServerService.$inject = ['jsonrpc'];


var JsonEditorServerDirective = function () {
    return {
        restrict: 'A',
        scope: {
            'editor': '@',
            'title': '@',
            'params': '=',
            'modal': '='
        },
        template: '<button class="btn btn-success" ng-click="open_modal()">' +
        '{{title}}</span>' +
        '</button>',
        controller: ['$scope', 'JsonEditorModal', 'JsonEditorServerService', 'toaster',
            function ($scope, JsonEditorModal, JsonEditorServerService, toaster) {
                $scope.open_modal = function () {
                    $scope.saving = null;
                    var editor_config_promise = JsonEditorServerService.get({editor_name: $scope.editor});
                    var model_promise = JsonEditorServerService.get_model({
                        editor_name: $scope.editor,
                        params: $scope.params
                    });
                    var schema_promise = JsonEditorServerService.get_schema({
                        editor_name: $scope.editor,
                        params: $scope.params
                    });
                    var modal_config = $scope.modal;

                    JsonEditorModal
                        .open(editor_config_promise, model_promise, schema_promise, modal_config)
                        .then(
                            function (model) {
                                JsonEditorServerService
                                    .update_model({
                                        editor_name: $scope.editor,
                                        params: $scope.params,
                                        initial_model_md5: model.md5,
                                        model: model.model
                                    })
                                    .then(function (result) {

                                    }, function (error) {
                                        toaster.pop({
                                            "type": "error",
                                            "title": error.name,
                                            "body": error.message
                                        });
                                    });
                            },
                            function (result) {

                            }
                        );
                }
            }]
    }
};

export default function(app){
    app.service('JsonEditorServerService', JsonEditorServerService);
    app.directive('amtJsonEditorServer', JsonEditorServerDirective)
};
